import React from 'react';
import SectionPliable from '../../../../composants/SectionPliable/SectionPliable';
import Banner from '../../../../composants/Banner/Banner';
import FilQuestionsReponses from './FilQuestionsReponses';
import './TabQuestionsReponses.css';

interface TabQuestionsReponsesProps {
  accordCadreId: number;
}

export const TITRE_QUESTIONS_REPONSES = 'Questions/Réponses (Support technique)';

const TabQuestionsReponses: React.FC<TabQuestionsReponsesProps> = ({ accordCadreId }) => (
  <SectionPliable title={TITRE_QUESTIONS_REPONSES}>
    <Banner
      variant="info"
      message="Pendant la consultation, il est possible d'échanger dans cet onglet pour toutes difficultés techniques rencontrées avec la plateforme. Les messages seront lus par tous les candidats, ils doivent donc être anonymes et ne pas mentionner d'éléments qui permettraient de vous identifier (à l'exception de l'acheteur). Pour toute question qui n'implique pas un problème technique, nous vous invitons à utiliser l'outil de questions/réponses du profil acheteur AWS pour la consultation en cours."
    />
    <FilQuestionsReponses accordCadreId={accordCadreId} />
  </SectionPliable>
);

export default TabQuestionsReponses;
